module.exports = __webpack_public_path__ + "static/media/foto4.93e2c048.jpg";